import React from "react";
import { IMAGES } from "@/assets/images";

// Static site image resolved from the asset registry by `storageKey`.
// Falls back to a gray labeled placeholder if the key isn't registered.
export const EditableImage = ({
  storageKey,
  label,
  className = "",
  style = {},
  rounded = 20,
  ...rest
}) => {
  const src = storageKey ? IMAGES[storageKey] : undefined;

  return (
    <div
      className={`editable-image ${className}`}
      style={{ position: "relative", borderRadius: rounded, ...style }}
      {...rest}
    >
      {src ? (
        <img
          src={src}
          alt={label}
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            borderRadius: rounded,
            display: "block",
          }}
        />
      ) : (
        <div className="ph" style={{ width: "100%", height: "100%", borderRadius: rounded }}>
          {label}
        </div>
      )}
    </div>
  );
};

export default EditableImage;
